var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 54 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4715"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.249 11.742a15.675 15.675 0 1 0 15.668 15.667 15.669 15.669 0 0 0-15.668-15.667Z",
    "data-name": "Path 24319"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.902.95h0a5.7 5.7 0 0 0 8.95 2.908h0l5.909 4.293h0a5.7 5.7 0 0 0 5.532 7.613h0l2.257 6.944h0a5.7 5.7 0 0 0 0 9.41h0l-2.257 6.947h0a5.7 5.7 0 0 0-5.532 7.613h0l-5.909 4.294h0a5.7 5.7 0 0 0-8.95 2.907h-7.3a5.7 5.7 0 0 0-8.949-2.907h0l-5.914-4.29h0a5.7 5.7 0 0 0-5.532-7.613h0L.95 32.122h0a5.7 5.7 0 0 0 0-9.41h0l2.257-6.947h0a5.7 5.7 0 0 0 5.532-7.613h0l5.909-4.293h0A5.7 5.7 0 0 0 23.597.951h7.3Z",
    "data-name": "Path 24320"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4716",
    transform: "translate(16.263 16.288)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 22.301a10.994 10.994 0 0 1 10.983-10.557 10.993 10.993 0 0 1 10.984 10.575",
    "data-name": "Path 24321"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.723,
    cy: 4.723,
    r: 4.723,
    "data-name": "Ellipse 635",
    transform: "translate(6.261)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.9bd69ac3dee1d6b7389811ac6fdfabe1.svg";
export { ForwardRef as ReactComponent };